import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Wraps page content with a simple opacity fade on route change.
 * 200ms ease-in-out fade-in on each navigation.
 */
const PageFade: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Restart the animation on every route change
    el.classList.remove("page-fade-in");
    // Force reflow so the animation restarts
    void el.offsetWidth;
    el.classList.add("page-fade-in");
  }, [location.pathname]);

  return (
    <div ref={ref} className="page-fade-in">
      {children}
    </div>
  );
};

export default PageFade;
